import { createActions } from 'src/utils/reduxUtils'

export const SignIn = createActions('SignIn')
export const SignUp = createActions('SignUp')
export const MCSignUp = createActions('MCSignUp')
export const ForgotPassword = createActions('ForgotPassword')
export const ResetPassword = createActions('ResetPassword')
export const FetchInvite = createActions('FetchInvite')
export const SetAuthTokens = createActions('SetAuthTokens')
export const Logout = createActions('Logout')

export const FetchUser = createActions('FetchUser')
export const FetchUserNotificationsConfig = createActions('FetchUserNotificationsConfig')
export const UpdateUserNotificationsConfig = createActions('UpdateUserNotificationsConfig')

export const FetchMarkets = createActions('FetchMarkets')
export const FetchOnboardingTemplates = createActions('FetchOnboardingTemplates')
export const SetSelectedMarket = createActions('SetSelectedMarket')

export const FetchOnboardingsCounts = createActions('FetchOnboardingsCounts')
export const FetchOnboardings = createActions('FetchOnboardings')
export const FetchOnboarding = createActions('FetchOnboarding')
export const FetchRecollectingSteps = createActions('FetchRecollectingSteps')
export const SendRemainderOnboarding = createActions('SendRemainderOnboarding')
export const SendRemainderContractor = createActions('SendRemainderContractors')

export const FetchPayments = createActions('FetchPayments')
export const UploadPaymentsCSV = createActions('UploadPaymentsCSV')
export const FetchPaymentInvoice = createActions('FetchPaymentInvoice')
export const DeletePayment = createActions('DeletePayment')
export const CancelPayment = createActions('CancelPayment')
export const ProcessPayments = createActions('ProcessPayments')
export const ProcessPayment = createActions('ProcessPayment')
export const ValidateSinglePayment = createActions('ValidateSinglePayment')
export const AddSinglePayment = createActions('AddSinglePayment')

export const FetchMCPayments = createActions('FetchMCPayments')
export const UploadMCPaymentsCSV = createActions('UploadMCPaymentsCSV')
export const FetchMCPaymentInvoice = createActions('FetchMCPaymentInvoice')
export const DeleteMCPayment = createActions('DeleteMCPayment')
export const ProcessMCPayments = createActions('ProcessMCPayments')
export const ProcessMCPayment = createActions('ProcessMCPayment')
export const ValidateSingleMCPayment = createActions('ValidateSingleMCPayment')
export const AddSingleMCPayment = createActions('AddSingleMCPayment')

export const FetchContractors = createActions('FetchContractors')
export const FetchContractorsCounts = createActions('FetchContractorsCounts')
export const FetchContractor = createActions('FetchContractor')
export const FetchSubcontractor = createActions('FetchSubcontractor')
export const FetchContractorActivitiesLogs = createActions('FetchContractorActivitiesLogs')
export const FetchContractorDeactivationDates = createActions('FetchContractorDeactivationDates')
export const SetContractorDeactivationDate = createActions('SetContractorDeactivationDate')
export const RemoveContractorDeactivationDate = createActions('RemoveContractorDeactivationDate')
export const FetchContractorSelfie = createActions('FetchContractorSelfie')
export const FetchSensitiveData = createActions('FetchSensitiveData')

export const FetchContractorNotes = createActions('FetchContractorNotes')
export const CreateContractorNote = createActions('CreateContractorNote')
export const UpdateContractorNote = createActions('UpdateContractorNote')
export const DeleteContractorNote = createActions('DeleteContractorNote')

export const InviteWorkersViaCSV = createActions('InviteWorkersViaCSV')

export const UploadPartnerDriversCSV = createActions('UploadPartnerDriversCSV')
export const CreatePartnerDriver = createActions('CreatePartnerDriver')
export const UpdatePartnerDriver = createActions('UpdatePartnerDriver')
export const ActivatePartnerDriver = createActions('ActivatePartnerDriver')
export const DeactivatePartnerDriver = createActions('DeactivatePartnerDriver')

export const CreateTag = createActions('CreateTag')
export const FetchTags = createActions('FetchTags')
export const DeleteTag = createActions('DeleteTag')
export const DriverAddTag = createActions('DriverAddTag')
export const DriverDeleteTag = createActions('DriverDeleteTag')

export const RejectOnboarding = createActions('RejectOnboarding')
export const UnrejectOnboarding = createActions('UnrejectOnboarding')

export const ApproveOnboardingStep = createActions('ApproveOnboardingStep')
export const RecollectOnboardingStep = createActions('RecollectOnboardingStep')
export const UpdateCollectData = createActions('UpdateCollectData')
export const DeclineOnboardingStep = createActions('DeclineOnboardingStep')
export const DownloadStepDocument = createActions('DownloadStepDocument')

export const SetActivityDetails = createActions('SetActivityDetails')

export const FetchDashboardsUpdates = createActions('FetchDashboardsUpdates')
export const FetchFailedPaymentsUpdates = createActions('FetchFailedPaymentsUpdates')
export const ViewDashboardsUpdates = createActions('ViewDashboardsUpdates')
export const SetDashboardsUpdates = createActions('SetDashboardsUpdates')

export const FetchTeamMembers = createActions('FetchTeamMembers')
export const FetchTeamMembersCount = createActions('FetchTeamMembersCount')
export const ActivateTeamMember = createActions('ActivateTeamMember')
export const DeactivateTeamMember = createActions('DeactivateTeamMember')
export const FetchTeamMember = createActions('FetchTeamMember')
export const UpdateTeamMemberAccess = createActions('UpdateTeamMemberAccess')

export const FetchTeamPermissions = createActions('FetchTeamPermissions')
export const FetchTeamRoles = createActions('FetchTeamRoles')
export const CreateTeamRole = createActions('CreateTeamRole')
export const UpdateTeamRole = createActions('UpdateTeamRole')
export const DeleteTeamRole = createActions('DeleteTeamRole')

export const FetchTeamMemberInvites = createActions('FetchTeamMemberInvites')
export const FetchTeamMemberInvitesCount = createActions('FetchTeamMemberInvitesCount')
export const SendInviteToTeamMember = createActions('SendInviteToTeamMember')
export const ResendTeamMemberInvite = createActions('ResendTeamMemberInvite')
export const FetchTeamMemberInvite = createActions('FetchTeamMemberInvite')
export const UpdateTeamMemberInviteAccess = createActions('UpdateTeamMemberInviteAccess')

export const FetchFundingSettings = createActions('FetchFundingSettings')
export const FetchFundingInvoice = createActions('FetchFundingInvoice')
export const CancelFundingInvoice = createActions('CancelFundingInvoice')
export const DownloadFundingInvoice = createActions('DownloadFundingInvoice')
export const ResetFundingInvoice = createActions('ResetFundingInvoice')
export const SubmitFundingMethodRequest = createActions('SubmitFundingMethodRequest')
export const SubmitFundingInvoiceRequest = createActions('SubmitFundingInvoiceRequest')
export const MCAddTag = createActions('MCAddTag')
export const MCDeleteTag = createActions('MCDeleteTag')
export const FetchPaymentsSummary = createActions('FetchPaymentsSummary')

export const SubcontractorAddTag = createActions('SubcontractorAddTag')
export const SubcontractorDeleteTag = createActions('SubcontractorDeleteTag')

export const UpdateSubcontractorMarket = createActions('UpdateSubcontractorMarket')
export const UpdateSubcontractorExternalId = createActions('UpdateSubcontractorExternalId')

export const FetchCustomerProfile = createActions('FetchCustomerProfile')

export const CustomerUploadBusinessInformation = createActions('CustomerUploadBusinessInformation')
export const CustomerUploadInsurance = createActions('CustomerUploadInsurance')
export const CustomerUploadUpdatedInsurance = createActions('CustomerUploadUpdatedInsurance')
export const CustomerUploadBusinessDetails = createActions('CustomerUploadBusinessDetails')
export const CustomerUploadUpdatedBusinessDetails = createActions(
  'CustomerUploadUpdatedBusinessDetails',
)
export const CustomerUploadTSA = createActions('CustomerUploadTSA')
export const CustomerUploadUpdatedTSA = createActions('CustomerUploadUpdatedTSA')
export const CustomerUploadSignContract = createActions('CustomerUploadSignContract')
export const CustomerUploadBankInformation = createActions('CustomerUploadBankInformation')

export const FetchCustomerDocusignSigningEnvelopeOptions = createActions(
  'FetchCustomerDocusignSigningEnvelopeOptions',
)

export const CustomerDocusignCompleteSigning = createActions('CustomerDocusignCompleteSigning')
export const CustomerDocusignDeclineSigning = createActions('CustomerDocusignDeclineSigning')
export const CustomerDocusignStartSigning = createActions('CustomerDocusignStartSigning')

export const CustomerStitchStartFlow = createActions('CustomerStitchStartFlow')
export const CustomerStitchCompletePayment = createActions('CustomerStitchCompletePayment')

export const FetchSubcontractorCounts = createActions('FetchSubcontractorCounts')

export const InviteMC = createActions('InviteMC')
export const ResendMCInvite = createActions('ResendMCInvite')
export const RejectMCInvite = createActions('RejectMCInvite')

export const FetchMCOnboardings = createActions('FetchMCOnboardings')
export const FetchMCOnboardingsCounts = createActions('FetchMCOnboardingsCounts')

export const FetchMCs = createActions('FetchMCs')
export const FetchMCsCounts = createActions('FetchMCsCounts')
export const FetchMC = createActions('FetchMC')
export const FetchMCsWithPendingRequests = createActions('FetchMCsWithPendingRequests')
export const UpdateMCExternalId = createActions('UpdateMCExternalId')
export const ActivateMC = createActions('ActivateMC')
export const DeactivateMC = createActions('DeactivateMC')

export const FetchMCCustomers = createActions('FetchMCCustomers')

export const FetchAcceptCustomerInviteDocusignSigningEnvelopeOptions = createActions(
  'FetchAcceptCustomerInviteDocusignSigningEnvelopeOptions',
)
export const AcceptCustomerInviteDocusignStartSigning = createActions(
  'AcceptCustomerInviteDocusignStartSigning',
)
export const AcceptCustomerInviteDocusignCompleteSigning = createActions(
  'AcceptCustomerInviteDocusignCompleteSigning',
)
export const AcceptCustomerInviteDocusignDeclineSigning = createActions(
  'AcceptCustomerInviteDocusignDeclineSigning',
)

export const FetchSubcontractorRequests = createActions('FetchSubcontractorRequests')
export const ApproveSubcontractorRequests = createActions('ApproveSubcontractorRequests')
export const DeclineSubcontractorRequests = createActions('DeclineSubcontractorRequests')

export const FetchContractorsPerCustomer = createActions('FetchContractorsPerCustomer')
export const FetchContractorsAvailableForAssign = createActions(
  'FetchContractorsAvailableForAssign',
)
export const AssignContractorsToCustomer = createActions('AssignContractorsToCustomer')
export const UnassignContractorsFromCustomer = createActions('UnassignContractorsFromCustomer')

export const EndPartnershipWithCustomer = createActions('EndPartnershipWithCustomer')
export const DeclineCustomerInvite = createActions('DeclineCustomerInvite')

export const FetchMCLiteRelations = createActions('FetchMCLiteRelations')
export const FetchAvailableMCLites = createActions('FetchAvailableMCLites')
export const FetchAvailableSubcontractorsForMCLite = createActions(
  'FetchAvailableSubcontractorsForMCLite',
)
export const AssignSubcontractorToMCLite = createActions('AssignSubcontractorToMCLite')
export const AssignMCLiteToSubcontractor = createActions('AssignMCLiteToSubcontractor')
export const UnassignSubcontractorToMCLite = createActions('UnassignSubcontractorToMCLite')
export const UnassignMCLiteToSubcontractors = createActions('UnassignMCLiteToSubcontractors')

export const FetchContractorFiles = createActions('FetchContractorFiles')
export const FetchContractorFile = createActions('FetchContractorFile')
export const DownloadContractorFile = createActions('DownloadContractorFile')
export const CreateContractorFile = createActions('CreateContractorFile')
export const UpdateContractorFile = createActions('UpdateContractorFile')
export const DeleteContractorFile = createActions('DeleteContractorFile')

export const FetchRejectionReasonsToDecline = createActions('FetchRejectionReasonsToDecline')
export const FetchRejectionReasons = createActions('FetchRejectionReasons')
export const CreateRejectionReason = createActions('CreateRejectionReason')
export const UpdateRejectionReason = createActions('UpdateRejectionReason')
export const DeleteRejectionReason = createActions('DeleteRejectionReason')
